var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoClone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.006,
    height: 16,
    viewBox: "0 0 21.006 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43880",
    "data-name": "Group 43880",
    transform: "translate(19959.506 24282.5)",
    fill: "#999",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48609",
    "data-name": "Path 48609",
    d: "M208.564,502.574a.044.044,0,0,0,.043-.042.049.049,0,0,0-.006-.023L201.378,489.6a.043.043,0,0,0-.081.019v12.917a.044.044,0,0,0,.043.042Zm0,1H201.34a1.054,1.054,0,0,1-1.063-1.042V489.615a1.054,1.054,0,0,1,1.063-1.041,1.066,1.066,0,0,1,.931.54l7.225,12.917h0a1.029,1.029,0,0,1,.131.5A1.054,1.054,0,0,1,208.564,503.574Z",
    transform: "translate(-20148.627 -24770.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48608",
    "data-name": "Path 48608",
    d: "M197.732,488.574a1.065,1.065,0,0,0-.931.541l-7.226,12.917h0a1.031,1.031,0,0,0,.425,1.414,1.079,1.079,0,0,0,.507.128h7.225a1.054,1.054,0,0,0,1.063-1.042V489.616A1.053,1.053,0,0,0,197.732,488.574Z",
    transform: "translate(-20148.445 -24770.574)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoClone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_clone.27dca494b2d88a69822eb27c6c7726eb.svg";